import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
// adjust path
import useApi from "../hooks/useApi";
import { getMenuAdminList, getMenuItemById, getMenuList } from "../services/adminApiService/menuApi/MenuApiService";

const MenuManagementContext = createContext();

export const MenuManagementProvider = ({ children }) => {

  const { loading, error, request } = useApi();
  const [menuDataList, setMenuDataList] = useState([]);
  const [sideabarmenuDataList, setSidebarMenuDataList] = useState([]);
  console.log("sideabarmenuDataList===>",sideabarmenuDataList)
  const [menuListById, setMenuListById] = useState([]);
  const [menuId, setMenuId] = useState([]);
  const [sidebarLoading, setSidebarLoading] = useState(false);

  const fetchMenuList = useCallback(async (perPage, currentPage) => {

    try {
      const response = await request(() =>
        getMenuAdminList(perPage, currentPage)
      );
      setMenuDataList(response?.data || []);
    } catch (err) {
      console.log("Menu List Error:", err);
    }
  }, [request]);


  const fetchSidebarMenuList = useCallback(async () => {
    try {
      setSidebarLoading(true);
      const response = await request(getMenuList);
      const menuList = response?.data?.data || [];

      // ✅ Extract only URLs
      const permissionRoutes = [
        ...new Set(
          menuList
            .flatMap((item) =>
              (item.children || []).map((child) =>
                child.url?.replace(/^\//, "")   // remove only starting '/'
              )
            )
            .filter((url) => url && url.trim() !== "")
        )
      ];

      // ✅ Store in localStorage
      localStorage.setItem("permission_route_url", JSON.stringify(permissionRoutes));
      setSidebarMenuDataList(response?.data || []);
    } catch (err) {
      console.log("Menu List Error:", err);
    } finally {
      setSidebarLoading(false);  // stop loader
    }
  }, [request]);

  const fetchMenuListById = useCallback(async (menuId) => {
    try {
      const response = await request(() => getMenuItemById(menuId));
      setMenuListById(response?.data?.data || []);
    } catch (err) {
      console.log("Menu List Error:", err);
    }
  }, [request]);



  return (
    <MenuManagementContext.Provider
      value={{
        loading,
        error,
        menuDataList,
        fetchSidebarMenuList,
        sideabarmenuDataList,
        fetchMenuList,
        fetchMenuListById,
        menuListById,
        setMenuId,
        menuId,
        sidebarLoading
      }}
    >
      {children}
    </MenuManagementContext.Provider>
  );
};

export const useMenuManagement = () => {
  return useContext(MenuManagementContext);
};